import i18n from '../../i18n';

export default function languageTranslation(component) {
  return i18n.t(component);
}
